module.exports = __webpack_public_path__ + "img/csr_111123_J.20657f95.jpg";